<template>
    <div>
        <template v-if="loan_tiers === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Loan Tier </h1>
                <router-link to="/addLoanTier" class="btn btn-primary active float-right"> Add Loan Tier </router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="loanTierTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th style="display: none;"></th>
                        <th>Name</th>
                        <th>Percentage Charges</th>
                        <th>Type</th>
                        <th>FED</th>
                        <th>Tenure</th>
                        <th>Bullet Tenure</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="loan_tiers === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="loan_tiers === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                loan_tiers : null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('loan_tiers').then(result => {
                this.loan_tiers = result.loan_tiers;
            }).then(result => {
                if(this.loan_tiers == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            callDataTable(){
                var that = this;
                var loanTier = $('#loanTierTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listLoanTiers",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": 'records'
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'charges'},
                        {data: 'loan_type'},
                        {data: 'fed'},
                        {data: 'installment_tenure'},
                        {data: 'bullet_payment_tenure'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editLoanTier/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 3 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    loanTier.search(this.value).draw();
                });
            }
        }
    }
</script>
